// extracted by mini-css-extract-plugin
export default {"header":"Header_header__dwyzz","title":"Header_title__hXLsD","logo":"Header_logo__oCHjt"};